const CONTACT_OPENING_HOUR = 9;
const CONTACT_CLOSING_HOUR = 21;

/**
 * Compute the contact line availability based on the current day and hour.
 * Open Monday to Saturday between 9h and 21h, closed on Sunday and outside
 * these hours.
 */
export const getContactAvailability = (): 'open' | 'close' => {
  const now = new Date();
  const day = now.getDay(); // 0 = dimanche
  const hour = now.getHours();
  const isOpen =
    day !== 0 && hour >= CONTACT_OPENING_HOUR && hour < CONTACT_CLOSING_HOUR;

  return isOpen ? 'open' : 'close';
};
